<template>
    <div class="supervisor-management-container container">
      <el-card shadow="hover">
        <template #header>
          <div class="card-header">
            <h2>إدارة حسابات المشرفين</h2>
            <el-button type="primary" @click="handleCreate">
              <el-icon><Plus /></el-icon> إضافة مشرف جديد
            </el-button>
          </div>
        </template>
  
        <el-alert
          title="إدارة مشرفي الطلاب"
          type="info"
          description="هذه الواجهة مخصصة لإنشاء وإدارة حسابات المستخدمين الخاصة بمشرفي الطلاب فقط."
          :closable="false"
          show-icon
          style="margin-bottom: 20px;"
        />
        
        <div class="filter-section">
          <el-input
            v-model="filters.search"
            placeholder="ابحث باسم المشرف أو اسم المستخدم..."
            @input="handleSearch"
            clearable
            style="width: 300px; margin-bottom: 20px;"
          />
        </div>
  
        <el-table :data="supervisors" v-loading="loading" border style="width: 100%">
          <el-table-column prop="name" label="اسم المشرف" min-width="180" />
          <el-table-column prop="username" label="اسم المستخدم" min-width="150" />
          <el-table-column prop="phone" label="رقم الهاتف" width="150" />
          <el-table-column prop="email" label="البريد الإلكتروني" min-width="200" />
          <el-table-column label="تاريخ الإنشاء" width="180">
              <template #default="{ row }">
                  {{ new Date(row.created_at).toLocaleDateString() }}
              </template>
          </el-table-column>
        </el-table>
  
        <div class="pagination-container">
          <el-pagination
            v-if="pagination.total > 0"
            @current-change="handlePageChange"
            :current-page="pagination.current_page"
            :page-size="pagination.per_page"
            :total="pagination.total"
            layout="total, prev, pager, next"
            background
          />
        </div>
      </el-card>
  
      <el-dialog v-model="dialogVisible" title="إنشاء حساب مشرف جديد" width="50%" :close-on-click-modal="false">
        <el-form :model="form" ref="formRef" label-position="top" :rules="rules">
          <el-row :gutter="20">
              <el-col :span="12">
                  <el-form-item label="اسم المشرف الكامل" prop="name">
                      <el-input v-model="form.name" />
                  </el-form-item>
              </el-col>
              <el-col :span="12">
                  <el-form-item label="اسم المستخدم" prop="username">
                      <el-input v-model="form.username" />
                  </el-form-item>
              </el-col>
          </el-row>
          <el-row :gutter="20">
              <el-col :span="12">
                  <el-form-item label="رقم الهاتف" prop="phone">
                      <el-input v-model="form.phone" />
                  </el-form-item>
              </el-col>
              <el-col :span="12">
                  <el-form-item label="البريد الإلكتروني" prop="email">
                      <el-input v-model="form.email" />
                  </el-form-item>
              </el-col>
          </el-row>
          <el-form-item label="العنوان" prop="address">
              <el-input v-model="form.address" />
          </el-form-item>
          <el-form-item label="كلمة المرور" prop="password">
            <el-input v-model="form.password" type="password" show-password />
          </el-form-item>
        </el-form>
        <template #footer>
          <span class="dialog-footer">
            <el-button @click="dialogVisible = false">إلغاء</el-button>
            <el-button type="primary" @click="submitForm" :loading="formLoading">إنشاء الحساب</el-button>
          </span>
        </template>
      </el-dialog>
    </div>
  </template>
  
  <script>
  import axios from 'axios';
  import { ElMessage } from 'element-plus';
  import { Plus } from '@element-plus/icons-vue';
  import debounce from 'lodash/debounce';
  
  export default {
    name: 'SupervisorManagement',
    components: { Plus },
    data() {
      return {
        api: null,
        loading: true,
        supervisors: [], // تم تغيير الاسم هنا
        filters: { search: '' },
        pagination: { current_page: 1, per_page: 15, total: 0 },
        
        dialogVisible: false,
        formLoading: false,
        form: this.getInitialForm(),
        rules: {
          name: [{ required: true, message: 'اسم المشرف مطلوب', trigger: 'blur' }],
          username: [{ required: true, message: 'اسم المستخدم مطلوب', trigger: 'blur' }],
          phone: [{ required: true, message: 'رقم الهاتف مطلوب', trigger: 'blur' }],
          address: [{ required: true, message: 'العنوان مطلوب', trigger: 'blur' }],
          password: [{ required: true, min: 8, message: 'كلمة المرور يجب أن تكون 8 أحرف على الأقل', trigger: 'blur' }],
        }
      };
    },
    created() {
      this.api = axios.create({ baseURL: process.env.VUE_APP_API_BASE_URL || 'https://cale.caledonian.ly/api' });
      this.api.interceptors.request.use((config) => {
        const token = localStorage.getItem('access_token');
        if (token) config.headers['Authorization'] = `Bearer ${token}`;
        return config;
      });
      this.fetchSupervisors(); // تم تغيير الاسم هنا
    },
    methods: {
      getInitialForm() {
        return { 
          name: '', 
          username: '', 
          email: '', 
          phone: '',
          address: '',
          password: '', 
          user_type: 'student supervisor' // ✨ القيمة الثابتة للمشرفين ✨
        };
      },
      async fetchSupervisors() { // تم تغيير الاسم هنا
        this.loading = true;
        try {
          const params = { 
              ...this.filters, 
              page: this.pagination.current_page, 
              per_page: this.pagination.per_page,
              user_type: 'student supervisor' // ✨ فلترة لجلب المشرفين فقط ✨
          };
          const response = await this.api.get('/get-users-super', { params });
          this.supervisors = response.data.data; // تم تغيير الاسم هنا
          this.pagination.total = response.data.total;
          this.pagination.current_page = response.data.current_page;
        } catch (error) {
          ElMessage.error('فشل في جلب بيانات المشرفين.');
        } finally {
          this.loading = false;
        }
      },
      handleSearch: debounce(function() {
        this.pagination.current_page = 1;
        this.fetchSupervisors(); // تم تغيير الاسم هنا
      }, 500),
      handlePageChange(page) {
        this.pagination.current_page = page;
        this.fetchSupervisors(); // تم تغيير الاسم هنا
      },
      handleCreate() {
          this.$refs.formRef?.resetFields();
          this.form = this.getInitialForm();
          this.dialogVisible = true;
      },
      async submitForm() {
        this.$refs.formRef.validate(async (valid) => {
          if (!valid) return;
  
          this.formLoading = true;
          try {
            // يستخدم نفس الـ endpoint لإنشاء المستخدمين
            await this.api.post('/users-super', this.form); 
            ElMessage.success('تم إنشاء حساب المشرف بنجاح!');
            this.dialogVisible = false;
            this.fetchSupervisors(); // تم تغيير الاسم هنا
          } catch (error) {
            const errorMsg = error.response?.data?.message || 'فشل في إنشاء الحساب.';
            ElMessage.error(errorMsg);
          } finally {
            this.formLoading = false;
          }
        });
      },
    },
  };
  </script>